<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    width?: number;
    height?: number;
    viewBox?: string;
  }>(),
  {
    viewBox: '0 0 42 42',
    height: 42,
    width: 42,
  },
);

const originalWidth = 42;
const originalHeight = 42;
const aspectRatio = originalWidth / originalHeight;

const computedWidth = computed(() => {
  if (props.width) return props.width;
  if (props.height) return props.height * aspectRatio;
  return originalWidth;
});

const computedHeight = computed(() => {
  if (props.height) return props.height;
  if (props.width) return props.width / aspectRatio;
  return originalHeight;
});
</script>

<template>
  <svg :width="computedWidth" :height="computedHeight" :viewBox="props.viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="21" cy="21" r="20.625" fill="#0F285B" stroke="#E0E0E0" stroke-width="0.75" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 21C10 14.9254 14.9254 10 21 10C27.0746 10 32 14.9254 32 21C32 27.0746 27.0746 32 21 32C14.9254 32 10 27.0746 10 21ZM11.8661 21C11.8661 26.0433 15.9567 30.1339 21 30.1339C26.0433 30.1339 30.1339 26.0433 30.1339 21C30.1339 15.9567 26.0433 11.8661 21 11.8661C15.9567 11.8661 11.8661 15.9567 11.8661 21ZM20.1666 17.5119C19.9456 17.2909 19.8214 16.9911 19.8214 16.6786C19.8214 16.366 19.9456 16.0662 20.1666 15.8452C20.3876 15.6242 20.6874 15.5 21 15.5C21.3126 15.5 21.6124 15.6242 21.8334 15.8452C22.0544 16.0662 22.1786 16.366 22.1786 16.6786C22.1786 16.9911 22.0544 17.2909 21.8334 17.5119C21.6124 17.733 21.3126 17.8571 21 17.8571C20.6874 17.8571 20.3876 17.733 20.1666 17.5119ZM20.2143 19.625C20.2143 19.517 20.3027 19.4286 20.4107 19.4286H21.5893C21.6973 19.4286 21.7857 19.517 21.7857 19.625V26.3036C21.7857 26.4116 21.6973 26.5 21.5893 26.5H20.4107C20.3027 26.5 20.2143 26.4116 20.2143 26.3036V19.625Z"
      fill="white"
    />
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
